import styled from "styled-components";

export const ServiceDetailsWrapper = styled.div`
  padding: 0 20px;
`;
